import type { PropsWithChildren } from "react";

export const UthevdTekst = ({ children }: PropsWithChildren) => (
  <strong className="font-semibold">
    <i>{children}</i>
  </strong>
);
